import React from "react";
import { Avatar, Flex, Text } from "@fluentui/react-northstar";
import styled from "styled-components/macro";

const CellFullnameAvatar = ({ fullname = "", avatar }) => {
    if (!fullname) return null;
    return (
        <Flex vAlign="center" gap="gap.smaller">
            <Avatar name={fullname} image={avatar} size="smaller" />
            <Fullname content={fullname} />
        </Flex>
    );
};

export default CellFullnameAvatar;

const Fullname = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-242424,
        #242424
    );

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
`;
